import React from 'react';
import { motion } from 'framer-motion';
const bonos = [{
  number: 1,
  image: 'https://images.unsplash.com/photo-1504148455328-c376907d081c?auto=format&fit=crop&w=200&q=70',
  title: 'Guía de Proveedores Japandi Argentina',
  description: 'El listado completo de dónde conseguir la madera, herrajes y terminaciones correctas en tu zona. Por región: CABA, GBA, Córdoba, Rosario y más.'
}, {
  number: 2,
  image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=200&q=70',
  title: 'Planilla de Costos y Precios de Venta',
  description: 'La fórmula exacta para calcular cuánto te costó cada mueble y cuánto cobrarlo. Con los 6 proyectos del Megapack ya cargados como ejemplo.'
}, {
  number: 3,
  image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=200&q=70',
  title: 'Pack de Planos Listos para Imprimir',
  description: 'Planos técnicos con medidas reales de los 6 muebles en formato A4. Los imprimís, los ponés en el taller y trabajás sin mirar la pantalla.'
}, {
  number: 4,
  image: 'https://images.unsplash.com/photo-1606857521015-7f9fcf423740?auto=format&fit=crop&w=200&q=70',
  title: 'Guía de Fotografía para Vender con el Celular',
  description: 'Cómo fotografiar tus muebles con el teléfono y que parezcan de revista. Luz, ángulo, fondo y edición básica incluidos.'
}, {
  number: 5,
  image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=200&q=70',
  title: 'Guía de Primeras Ventas: De 0 a tu Primer Cliente',
  description: 'Qué decir, dónde publicar y cómo cerrar tu primera venta aunque no tengas seguidores ni experiencia vendiendo nada.'
}];
export function Bonos() {
  return <section className="py-8 md:py-16 px-4 bg-white" data-id="element-18">
      <div className="max-w-7xl mx-auto" data-id="element-19">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-5xl font-bold text-center mb-2 md:mb-4" data-id="element-20">
          INCLUIDOS GRATIS
        </motion.h2>

        <p className="text-center text-sm md:text-lg mb-2 md:mb-4 text-[#2B2724]/80" data-id="element-21">
          5 Bonos de Alto Valor
        </p>

        <p className="text-center text-xs md:text-sm mb-5 md:mb-8 text-[#2B2724]/60" data-id="element-22">
          Sin costo extra — incluidos en todas las ofertas
        </p>

        <div className="flex flex-col md:grid md:grid-cols-2 gap-2.5 md:gap-3 mb-5 md:mb-8" data-id="element-23">
          {bonos.map((bono, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.08
        }} whileTap={{
          scale: 0.98
        }} className="flex items-center gap-3 bg-[#F5F0E8] p-2.5 md:p-3 rounded-lg border border-[#2B2724]/10 relative" data-id="element-24">
              <img src={bono.image} alt={bono.title} className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 rounded-lg object-cover" data-id="element-25" />
              <div className="flex-1 min-w-0 pr-14 md:pr-16" data-id="element-26">
                <h3 className="font-bold text-xs md:text-sm leading-tight" data-id="element-27">
                  <span className="text-[#C2613A]" data-id="element-28">Bono {bono.number}</span> ·{' '}
                  {bono.title}
                </h3>
                <p className="text-[10px] md:text-xs text-[#2B2724]/70 leading-snug mt-0.5" data-id="element-29">
                  {bono.description}
                </p>
              </div>
              <span className="absolute top-2 right-2 md:top-3 md:right-3 bg-[#8B9A8E] text-white text-[9px] md:text-[10px] px-2 py-0.5 rounded-full font-semibold" data-id="element-30">
                GRATIS
              </span>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#C2613A] text-white py-3 px-4 md:py-4 md:px-6 rounded-lg text-center" data-id="element-31">
          <p className="text-lg md:text-2xl font-bold" data-id="element-32">
            VALOR TOTAL: $45.000 — GRATIS
          </p>
        </motion.div>
      </div>
    </section>;
}